<template>
    <div>
        <top :id="'help'"></top>
        <div class="con">
            <breadcrumb :url="url"></breadcrumb>
            <div class="flex">
                <div class="left">
                    <div class="help">
                        <div
                            class="help-item"
                            v-for="(item, index1) in help"
                            :key="index1"
                        >
                            <div
                                class="help-title"
                                :class="{ blue: helpTitleId == index1 }"
                                :style="index1 == 0 ? 'border-top:none' : ''"
                                @click="clickHelp(index1)"
                            >
                                <i :class="item.icon + 'iconfont'"></i>
                                <span>{{ item.title }}</span>
                                <i class="ficon-down iconfont"></i>
                            </div>
                            <div
                                class="help-child"
                                v-if="index1 == helpTitleId"
                            >
                                <div
                                    class="help-text"
                                    @click="click(items.richtext_id, index1)"
                                    v-for="(items, i) in item.children"
                                    :key="i"
                                >
                                    <span
                                        :class="{
                                            'help-text-true':
                                                helpId == items.richtext_id
                                        }"
                                        >{{ items.title }}</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <client v-if="helpIds == 5" @checkView="checkView" v-bind:checkId = "helpId"></client>
                    <clause v-if="helpIds == 6" @checkView="checkView" v-bind:checkId = "helpId"></clause>
                    <statement
                        v-if="helpIds == 7"
                        @checkView="checkView"
                        v-bind:checkId = "helpId"
                    ></statement>
                    <payment
                        v-if="helpIds == 8"
                        @checkView="checkView"
                        v-bind:checkId = "helpId"
                    ></payment>
                    <orderHelp
                      v-if="helpIds == 9"
                      @checkView="checkView"
                      v-bind:checkId = "helpId"
                    ></orderHelp>
                    <about  v-if="helpIds == 10"
                      @checkView="checkView"
                      v-bind:checkId = "helpId"></about>
                     <agreement
                      v-if="helpIds == 1"
                      @checkView="checkView"
                      v-bind:checkId = "helpId"
                     ></agreement>
                     <privacy
                     v-if="helpIds == 2"
                     @checkView="checkView"
                      v-bind:checkId = "helpId"
                     >

                     </privacy>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
import { indexHelp } from "@/api/index.js";
import top from "../../../components/top.vue";
import bottom from "../../../components/bottom.vue";
import breadcrumb from "../../../components/breadcrumb.vue";

// 顾客必读
import client from "./compontents/client.vue";
// 条款
import clause from "./compontents/clause.vue";
//声明
import statement from "./compontents/statement.vue";
//支付
import payment from "./compontents/payment.vue";
//订单
import orderHelp from "./compontents/orderHelp.vue";
//关于
import about from './compontents/about.vue'
//协议
import agreement from './compontents/agreement'
//隐私
import privacy from './compontents/privacy'


export default {
    components: {
        top,
        bottom,
        breadcrumb,
        client,
        clause,
        statement,
        payment,
        orderHelp,
        about,
        agreement,
        privacy
    },
    data() {
        return {
            url: [{ name: "帮助中心", url: "/help" }],
            help: [],
            helpId: 5,
            helpTitleId: 0
        };
    },

    created() {

    },
    mounted(){
        this.getindexRichtext();
    },
    computed:{
    helpIds(){
    return this.helpId = this.$route.query.id
    }
    },
    methods: {
        click(e, id) {
            // console.log(e);
            this.helpId = this.$router.push({path:'/help',query:{id:e}});
            this.helpTitleId = id;
        },
        clickHelp(e) {
            console.log(e);
            if (e == this.helpTitleId) {
                this.helpTitleId = -1;
            } else {
              this.helpTitleId = e;
            //   console.log(this.$route.query.rich_id);
            //   console.log(e);

            }
        },
        checkView(e) {
            // console.log('.');
            this.helpId = e.helpId;
        },
        getindexRichtext() {
            indexHelp({}).then(res => {
                // console.log(res.data.list);
                if(res.code !== 1){
                    return
                }
                // console.log(res.data.list);
                this.help = res.data.list;
            });
        }
    }
};
</script>

<style lang="less" scoped>
.border {
    border: none !important;
}
.con {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 30px;
}
.left {
    margin-right: 10px;
    .user {
        width: 210px;
        height: 94px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #0097fe;
        margin-bottom: 20px;
        img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .help {
        width: 211px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #0097fe;
        .help-item {
            .help-title {
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
                border-bottom: solid 1px #d5d5d5;
                border-top: solid 1px #d5d5d5;
                span {
                    margin: 0 10px;
                }
            }

            .help-child {
                text-align: center;
                color: #999;
                font-size: 16px;
                .help-text {
                    height: 40px;
                    line-height: 40px;
                }
                .help-text-true {
                    color: #0097fe;
                    border-bottom: 2px solid;
                }
            }
        }
    }
}
.right {
    width: 100%;
    border: 1px solid #0097fe;
    border-radius: 8px;
    padding: 30px;
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/index/help/help.vue